import { render, staticRenderFns } from "./RecommendedFile.vue?vue&type=template&id=3dc2f712&scoped=true"
import script from "./RecommendedFile.vue?vue&type=script&lang=js"
export * from "./RecommendedFile.vue?vue&type=script&lang=js"
import style0 from "./RecommendedFile.vue?vue&type=style&index=0&id=3dc2f712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2f712",
  null
  
)

export default component.exports